import { render, staticRenderFns } from "./AtualizarPlanilha.vue?vue&type=template&id=31d0e244"
import script from "./AtualizarPlanilha.vue?vue&type=script&lang=js"
export * from "./AtualizarPlanilha.vue?vue&type=script&lang=js"
import style0 from "./AtualizarPlanilha.vue?vue&type=style&index=0&id=31d0e244&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports